import { Box } from '@televet/kibble-ui/build/chakra';
import { Text } from '@televet/kibble-ui/build/components/Text';
import { Task } from 'pages/Tasks/types';
import React from 'react';

type TaskDetailCustomProps = {
  task: Task;
};

const TaskDetailCustom = ({ task }: TaskDetailCustomProps): JSX.Element => {
  return (
    <Box pl={3} px={4} borderLeftWidth="2px" borderLeftColor={'border.info'}>
      <Text size="sm">{task.description}</Text>
    </Box>
  );
};

export default TaskDetailCustom;
